module.exports = __webpack_public_path__ + "img/satisfaction-main.a532ae0.png";